import Repository from "./Repository";

export default {
  getUnRegistersColleges(payload) {
    return Repository.get(
      `/un-registered-colleges?city=${payload.city}&state=${payload.state}&institute=${payload.institute}&pageSize=${payload.pageSize}&lastDocId=${payload.lastDocId}`
    );
  },
};
